import {
  generateCompanyElectionsTable,
  generateGroupElectionsTable,
} from "../tables/elections";
import { defaultFontNormal } from "../utils/styling";
import {
  generateSectionParagraphs,
  getSectionHeader,
} from "../utils/WordExportUtils";

export const getElectionsParagraphs = (data) => {
  const { poaData } = data;

  const groupElectionsTable = generateGroupElectionsTable(data);
  const companyElectionsTable = generateCompanyElectionsTable(data);

  const returnExists = [
    "Full",
    "Abbreviated",
    "Amended - Abbreviated",
  ].includes(poaData?.return_status?.type);

  const paragraphsPart1 = [
    {
      condition: returnExists,
      segments: [
        {
          text: "The return has been prepared on the basis that the following elections will either be made in the return, or otherwise apply in relation to the return period:",
          font: defaultFontNormal,
        },
      ],
    },
    {
      condition: !returnExists,
      segments: [
        {
          text: "No return has been prepared on the basis that there is no reporting company nominated for the period. In order to make elections for the group, it is generally necessary to have a nominated reporting company in place. However, some elections can be made without a reporting company and we understand that the following elections will apply in relation to the period:",
          font: defaultFontNormal,
        },
      ],
    },
  ];

  const paragraphsPart2 = [
    {
      segments: [
        {
          text: "Further detail on the application of these elections is included in Appendix 2.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
    {
      segments: [
        {
          text: "The making of other elections falls outside the scope of our CIR review. Appendix 2 contains a summary of other claims and elections available under the CIR legislation - please ensure that you review these and let us know if you would like to discuss the potential application of any additional claims and elections.",
          font: defaultFontNormal,
          break: 1,
        },
      ],
    },
  ];

  return [
    getSectionHeader("Elections"),
    ...generateSectionParagraphs(paragraphsPart1),
    ...groupElectionsTable,
    ...companyElectionsTable,
    ...generateSectionParagraphs(paragraphsPart2),
  ];
};
